import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';

import { MockToolCard } from '../MockToolCard';

const mockArr = ['', '', '', '', '', '', '', '', ''];
type Props = {
  title: string;
  showSwiper?: boolean;
};

const SkeletonPage = ({ showSwiper, title }: Props) => (
  <>
    {showSwiper && (
      <div className='border-t-2'>
        <div className='overflow-hidden m-6 xs:m-4'>
          <div className='max-w-[715px] sm:!max-w-[428px] md:max-w-[470px] xs:!max-w-[352px] mx-auto w-max xxs:w-full'>
            <div className='mx-auto pb-4'>
              <h2 className='text-lg leading-xl font-bold'>For you</h2>
            </div>
            <Swiper
              modules={[FreeMode]}
              slidesPerView='auto'
              spaceBetween={12}
              centerInsufficientSlides
              breakpoints={{ 480: { spaceBetween: 20 } }}
              className='overflow-visible'
            >
              {mockArr.map(() => (
                <SwiperSlide className='w-[204px] sm:w-[180px] xs:w-[170px]' key={Math.random()}>
                  <MockToolCard size='small' />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    )}
    <div className='border-t-2 w-auto'>
      <div className='mx-auto w-max p-6 xs:p-4 xxs:mx-0 xxs:w-full'>
        <h2 className='text-lg leading-xl font-bold mb-4'>All {title}</h2>
        <ul className='grid xxs:grid-cols-1 gap-5 md:grid-cols-2 grid-cols-3 w-max xs:gap-3 xxs:mx-auto'>
          {mockArr.map(() => (
            <li key={Math.random()}>
              <MockToolCard size='large' />
            </li>
          ))}
        </ul>
      </div>
    </div>
  </>
);

export { SkeletonPage };
